<template lang="pug">
v-container(grid-list-xl fluid class='data-filter pt-3 pb-2')
  v-layout(row wrap)
    v-flex(xs12 sm4)
      v-text-field(
        :loading='loading'
        :value='initial'
        @input='$emit("search", $event)'
        hide-details
        prepend-inner-icon='search'
        label='Поиск'
        clearable
      )
    v-flex(xs12 sm8)
      slot(name='controls')
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    initial: {
      type: String
    }
  }
}
</script>

<style scoped>
.data-filter >>> .v-text-field__details {
  display: none;
}
</style>
